//tslint:disable:max-file-line-count await-promise
import { ErrorLogComponent } from '@cian/error-log-component';
import { ILogger } from '@cian/logger';
import { Config } from '@cian/config';
import { Preloader } from '@cian/preloader-component';
import { IHttpApi } from '@cian/http-api/shared';
import * as React from 'react';
import * as url from 'url';
import classNames from 'classnames';

import { ISeoState, TDeviceType, TUser, IQuickLinks } from '../../state';
import { CoworkingProfitBannerContainer } from '../../../containers/CoworkingProfitBannerContainer';
import { TrapContainer, ObservableTrapContainer } from '../../../serp/components/demand';
import { Filters } from '../../../filters/components/filters';
import { TTag } from '../../../filters/state/tags';
import { IOffer } from '../../../offer/types';
import { SeoTopBanners } from '../../../serp/components/adfox/seo_top_banners';
import { BottomSubscribeContainer } from '../../../serp/components/bottom_subscribe/container';
import { FastLinksContainer } from '../../../serp/components/fast_links/container';
import { HeaderContainer } from '../../../serp/components/header/container';
import { NewobjectsContainer } from '../../../serp/components/newobjects/container';
import { NewobjectsFromDeveloperContainer } from '../../../serp/components/newobjects_from_developer/container';
import { OffersContainer } from '../../../serp/components/offers/container';
import { OfficeCalculatorContainer } from '../../../serp/components/office_calculator/container';
import { PaginationContainer } from '../../../serp/components/pagination/container';
import { PromoteMobile } from '../../../serp/components/promote_mobile';
import { SuggestionsContainer } from '../../../serp/components/suggestions/container';
import { SummaryContainer } from '../../../serp/containers/SummaryContainer';
import { QuickLinksContainer } from '../../../serp/containers/QuickLinksContainer';
import { isArrayWithItems } from '../../../utils';
import { BannerContainer } from '../Banner';

// Filter modals
import { AdvancedContainer } from '../../../filters/components/advanced/container';
import { DirectionsContainer } from '../../../filters/components/directions/modal/container';
import { DistrictsContainer } from '../../../filters/components/districts/container';
import LocationSwitherContainer from '../../../filters/components/location_switcher/container';
import { MapContainer } from '../../../filters/components/map/container';
import { MetroContainer } from '../../../filters/components/metro/container';
import { ILocation } from '../../../api/locations';
import { IJsonQuery } from '../../../json_query';
import { logComponentError } from '../../../utils/log_component_error';
import { IMakeRequest } from '../../../utils/request';
import { HideOfferTopPopup } from '../../../serp/components/hide_offer_top_popup';
import { EHideOfferState } from '../../../serp/state/hide_offer';
import { parseHash } from '../../../utils/hash';
import { readAllOffersForSavedSearches } from '../../../api/saved_searches/readAllOffers';
import { PreInfiniteBanner } from '../PreInfiniteBanner';
import { EPreInfiniteBannerTypes } from '../PreInfiniteBanner/PreInfiniteBanner';
import { VerifyPhoneContainer } from '../../../serp/components/verifyPhone';
import { CoworkingModalAd, CoworkingModalAdMini, CoworkingPopup } from '../CoworkingExperiments';

import { saveJsonQueryInLocalStorage } from '../../../utils/save_json_query';

import { NpsWidgetContainer } from './NpsWidgetContainer';
import { Collections } from '../../../serp/components/Collections/Collections';

import { SurveyWidgetModal } from '../SurveyWidgetModal';

import { NewbuildingChatContainer } from '../NewbuildingChat';
import { NewbuildingConsultantPopupContainer } from '../NewbuildingConsultantPopup';
import { SeoBotCatcherLinksContainer } from '../../../serp/containers/SeoBotCatcherLinksContainer';
import { SeoCrossLinksContainer } from '../../../serp/containers/SeoCrossLinksContainer';
import { FiltersContainer } from '../../../containers/FiltersContainer';
import { FavoritesFoldersContainer } from '../../../containers/FavoritesFoldersContainer';
import { shouldSendAdsEvent } from '../../../utils/shouldSendAdsEvent';
import { ProfessionalSearchPromoContainer } from '../../../containers/ProfessionalSearchPromoContainer';

const style = require('./index.css');

const FLOCTORY_CHECK_TIMEOUT = 1500;

export interface IContext {
  logger: ILogger;
}

export interface ISearchEngineResultsPageProps {
  currency: string;
  context: IContext;
  deviceType: TDeviceType;
  baseUrl: string;
  isFetching: boolean;
  isPromotionMobileClosed: boolean;
  isPrintEnabled: boolean;
  seo: ISeoState;
  subdomain: string;
  offers: IOffer[];
  quickLinks: IQuickLinks | null;
  aggregatedOffers: number;

  regions: ILocation[];
  currentLocation: ILocation | 'moscow_mo' | 'spb_lo';
  jsonQuery: IJsonQuery;
  tags: TTag[];

  user: TUser;
  isAdvancedModalVisible: boolean;
  isDirectionsModalVisible: boolean;
  isDistrictModalVisible: boolean;
  isLocationSwitcherVisible: boolean;
  isMapModalVisible: boolean;
  isStalkerBannerShown: boolean;
  isMetroModalVisible: boolean;
  isOfficeCalculatorVisible: boolean;
  isSignInTriggerModalOpen: boolean;
  showTrap: boolean;
  makeRequest: IMakeRequest;
  isTopPopupOpened: boolean;
  hideOfferState: EHideOfferState;
  hideOfferErrorMessage: string;
  lkUrl: string;

  totalOffers: number;

  httpApi: IHttpApi;
  queryString: string;

  showPreInfinteSaveSearchBanner?: boolean;
  isCardVisibilityObservationExperiment?: boolean;

  currentUrl: string | undefined;
  isLightView: boolean;
  isOfferInSavedSearch?: boolean;
  isPromoCollectionsEnabled: boolean;
  isCommercialSurveyWidgetModalOpen: boolean;
  isRedesignEnabled: boolean;
  isFiltersRedesignEnabled: boolean;
  config: Config;

  isCoworkingExperimentsEnabled: boolean;
  isProfessionalSearchPromoEnabled: boolean;
}

export interface ISearchEngineResultsPageDispatchProps {
  setKeyPushNotificationValue(value: boolean): void;
  setHideOfferState(hideOfferState: EHideOfferState): void;
  setLoading(): void;
  onOffersScrollsToTop(): void;
}

export interface ISearchEngineResultsState {
  isMounted: boolean;
}

export type TSearchEngineResultsPageProps = ISearchEngineResultsPageProps & ISearchEngineResultsPageDispatchProps;

export class SearchEngineResultsPage extends React.Component<TSearchEngineResultsPageProps, ISearchEngineResultsState> {
  public context: IContext;
  public state = {
    isMounted: false,
  };

  /* istanbul ignore next */
  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    logComponentError({
      error,
      errorInfo,
      logger: this.props.context.logger,
    });
  }

  private offersDiv: HTMLDivElement | null;

  /* istanbul ignore next */
  public componentDidMount() {
    const { setKeyPushNotificationValue, setHideOfferState, httpApi, context, queryString, jsonQuery } = this.props;

    saveJsonQueryInLocalStorage(jsonQuery);

    const checkFlocktoryLoad: Promise<IFlocktory> = new Promise(resolve => {
      const flocktoryAttempt = () => {
        if (window.flocktory && typeof window.flocktory.getSubscriptionStatus === 'function') {
          // tslint:disable-next-line: no-use-before-declare
          clearTimeout(timeIntervalFlocktoryCheck);

          return resolve(window.flocktory);
        }

        // tslint:disable-next-line: no-use-before-declare
        timeIntervalFlocktoryCheck = setTimeout(flocktoryAttempt, FLOCTORY_CHECK_TIMEOUT);
      };

      let timeIntervalFlocktoryCheck = setTimeout(flocktoryAttempt, FLOCTORY_CHECK_TIMEOUT);
    });

    checkFlocktoryLoad.then(flocktory => {
      flocktory.getSubscriptionStatus().then(response => {
        /**
         * Если flocktory вернули поле subscribed и оно равно false,
         * значит текущий пользователь не подписан на пуши.
         */
        if ('subscribed' in response && !response.subscribed) {
          setKeyPushNotificationValue(true);
        }
      });
    });

    /**
     * При уходе с выдачи по сохраненному поиску отметить все "новые" оферы просмотренными
     */
    window.addEventListener('beforeunload', () => {
      const queryStringObj = url.parse(`/?${queryString}`, true);
      const savedSearchId = Number(queryStringObj.query['saved_search_id']);

      if (savedSearchId) {
        readAllOffersForSavedSearches(httpApi, { savedSearchId }, context.logger);
      }
    });

    /* istanbul ignore next */
    window.addEventListener('popstate', async () => {
      this.props.setLoading();
      window.location.reload();
    });

    const parsedHash = parseHash(window.location.hash);
    if (Object.keys(parsedHash).includes('HIDE')) {
      setHideOfferState(parsedHash['HIDE'] as EHideOfferState);
      history.pushState('', document.title, window.location.pathname + window.location.search);
    }

    this.setState({ isMounted: true });

    // TODO: будет отрефакторено или выпилено в CD-100589
    this.offersDiv = document.querySelector('div[data-name="Offers"]');
    window.addEventListener('scroll', this.handleScroll);
  }

  /* istanbul ignore next */
  public componentWillUnmount() {
    this.setState({ isMounted: false });

    // TODO: будет отрефакторено или выпилено в CD-100589
    window.removeEventListener('scroll', this.handleScroll);
  }

  /* istanbul ignore next */
  public render() {
    const {
      baseUrl,
      deviceType,
      isFetching,
      isPrintEnabled,
      isPromotionMobileClosed,
      offers,
      quickLinks,
      seo,
      aggregatedOffers,
      totalOffers,
      makeRequest,
      isTopPopupOpened,
      hideOfferState,
      hideOfferErrorMessage,
      isCardVisibilityObservationExperiment,
      isLightView,
      showTrap,
      isOfferInSavedSearch,
      isPromoCollectionsEnabled,
      isCommercialSurveyWidgetModalOpen,
      isRedesignEnabled,
      isFiltersRedesignEnabled,
      isProfessionalSearchPromoEnabled,
    } = this.props;

    const isQuickLinksAvailable =
      quickLinks &&
      isArrayWithItems(quickLinks.links) &&
      quickLinks.links.some(({ offersCount }) => Boolean(offersCount));

    return (
      <div className={classNames(style['serp'], { [style['serp--light']]: isLightView || isRedesignEnabled })}>
        {seo.text && <div className={style['seoText']} dangerouslySetInnerHTML={{ __html: seo.text }} />}
        <ErrorLogComponent logger={this.props.context.logger}>
          {isFiltersRedesignEnabled ? <FiltersContainer /> : <Filters />}
        </ErrorLogComponent>
        {isFetching && (
          <div className={style['preloadOverlay']}>
            <Preloader size={50} preloaderStyle={style['preloader']} />
          </div>
        )}
        <ErrorLogComponent logger={this.props.context.logger}>
          <BannerContainer />
        </ErrorLogComponent>
        {isQuickLinksAvailable && isLightView && (
          <ErrorLogComponent logger={this.props.context.logger}>
            <QuickLinksContainer />
          </ErrorLogComponent>
        )}
        <ErrorLogComponent logger={this.props.context.logger}>
          <div className={style['coworking-profit-banner-container']}>
            <CoworkingProfitBannerContainer containerClassName={style['coworking-profit-banner']} />
          </div>
        </ErrorLogComponent>
        <ErrorLogComponent logger={this.props.context.logger}>
          <HeaderContainer />
        </ErrorLogComponent>
        {aggregatedOffers > 0 && (
          <ErrorLogComponent logger={this.props.context.logger}>
            <SummaryContainer />
          </ErrorLogComponent>
        )}
        {deviceType !== 'desktop' && !isPromotionMobileClosed && (
          <ErrorLogComponent logger={this.props.context.logger}>
            <PromoteMobile />
          </ErrorLogComponent>
        )}
        {isQuickLinksAvailable && !isLightView && (
          <ErrorLogComponent logger={this.props.context.logger}>
            <QuickLinksContainer />
          </ErrorLogComponent>
        )}
        {isProfessionalSearchPromoEnabled && (
          <ErrorLogComponent logger={this.props.context.logger}>
            <ProfessionalSearchPromoContainer />
          </ErrorLogComponent>
        )}
        {isLightView && (
          <div className={style['delimiter']}>
            <hr />
          </div>
        )}
        {isPromoCollectionsEnabled && <Collections />}
        <ErrorLogComponent logger={this.props.context.logger}>
          <OffersContainer />
        </ErrorLogComponent>
        <ErrorLogComponent logger={this.props.context.logger}>
          <NewobjectsContainer />
        </ErrorLogComponent>
        <ErrorLogComponent logger={this.props.context.logger}>
          <NewobjectsFromDeveloperContainer />
        </ErrorLogComponent>

        <ErrorLogComponent logger={this.props.context.logger}>
          {this.props.showPreInfinteSaveSearchBanner && (
            <PreInfiniteBanner
              type={EPreInfiniteBannerTypes.subscription}
              isOfferInSavedSearch={isOfferInSavedSearch}
            />
          )}
        </ErrorLogComponent>

        <ErrorLogComponent logger={this.props.context.logger}>
          <SuggestionsContainer />
        </ErrorLogComponent>

        <ErrorLogComponent logger={this.props.context.logger}>
          <PaginationContainer />
        </ErrorLogComponent>

        {showTrap && (
          <div className={style['wrapper']}>
            <ErrorLogComponent logger={this.props.context.logger}>
              {isCardVisibilityObservationExperiment ? <ObservableTrapContainer /> : <TrapContainer />}
            </ErrorLogComponent>
          </div>
        )}

        <ErrorLogComponent logger={this.props.context.logger}>
          <VerifyPhoneContainer />
        </ErrorLogComponent>

        <div className={style['wrapper']}>
          {!this.props.showPreInfinteSaveSearchBanner && (aggregatedOffers > 0 || totalOffers > 0) && (
            <ErrorLogComponent logger={this.props.context.logger}>
              <BottomSubscribeContainer />
            </ErrorLogComponent>
          )}
          <ErrorLogComponent logger={this.props.context.logger}>
            <SeoCrossLinksContainer />
          </ErrorLogComponent>
        </div>

        <ErrorLogComponent logger={this.props.context.logger}>
          <FastLinksContainer />
        </ErrorLogComponent>
        {!isPrintEnabled && (
          <ErrorLogComponent logger={this.props.context.logger}>
            <SeoTopBanners
              offers={offers}
              baseUrl={baseUrl}
              isAgent={this.props.user.isAuthenticated && this.props.user.isAgent}
              makeRequest={makeRequest}
              shouldSendAdsEvent={shouldSendAdsEvent(this.props.jsonQuery)}
            />
          </ErrorLogComponent>
        )}

        {this.props.isAdvancedModalVisible && (
          <ErrorLogComponent logger={this.props.context.logger}>
            <AdvancedContainer />
          </ErrorLogComponent>
        )}
        {this.props.isMapModalVisible && (
          <ErrorLogComponent logger={this.props.context.logger}>
            <MapContainer />
          </ErrorLogComponent>
        )}
        {this.props.isMetroModalVisible && (
          <ErrorLogComponent logger={this.props.context.logger}>
            <MetroContainer />
          </ErrorLogComponent>
        )}
        {this.props.isLocationSwitcherVisible && (
          <ErrorLogComponent logger={this.props.context.logger}>
            <LocationSwitherContainer />
          </ErrorLogComponent>
        )}
        {this.props.isDistrictModalVisible && (
          <ErrorLogComponent logger={this.props.context.logger}>
            <DistrictsContainer />
          </ErrorLogComponent>
        )}
        {this.props.isDirectionsModalVisible && (
          <ErrorLogComponent logger={this.props.context.logger}>
            <DirectionsContainer />
          </ErrorLogComponent>
        )}
        {this.props.isOfficeCalculatorVisible && (
          <ErrorLogComponent logger={this.props.context.logger}>
            <OfficeCalculatorContainer />
          </ErrorLogComponent>
        )}

        {this.state.isMounted && isTopPopupOpened && (
          <HideOfferTopPopup
            isError={hideOfferState === EHideOfferState.ERROR}
            lkUrl={this.props.lkUrl}
            errorMessage={hideOfferErrorMessage}
          />
        )}

        {isCommercialSurveyWidgetModalOpen && (
          <ErrorLogComponent logger={this.props.context.logger}>
            <SurveyWidgetModal />
          </ErrorLogComponent>
        )}

        <ErrorLogComponent logger={this.props.context.logger}>
          <CoworkingModalAd />
        </ErrorLogComponent>

        <ErrorLogComponent logger={this.props.context.logger}>
          <CoworkingModalAdMini className={style['coworking-ad-modal-mini']} />
        </ErrorLogComponent>

        <ErrorLogComponent logger={this.props.context.logger}>
          <CoworkingPopup className={style['coworking-popup']} />
        </ErrorLogComponent>

        <NewbuildingConsultantPopupContainer />
        <NewbuildingChatContainer />

        <FavoritesFoldersContainer />

        <NpsWidgetContainer />
        <ErrorLogComponent logger={this.props.context.logger}>
          <SeoBotCatcherLinksContainer />
        </ErrorLogComponent>
      </div>
    );
  }

  // TODO: будет отрефакторено или выпилено в CD-100589
  private handleScroll = () => {
    if (!this.offersDiv) {
      return;
    }

    const { onOffersScrollsToTop, isCoworkingExperimentsEnabled } = this.props;
    const { top: offersDivTopPosition } = this.offersDiv.getBoundingClientRect();

    if (isCoworkingExperimentsEnabled && offersDivTopPosition <= 0) {
      onOffersScrollsToTop();
    }
  };
}
